import type { ChangeEvent, FocusEvent } from 'react';

export default function useInputHandlers(cb: (val: string) => void) {
  const onChange = (e: ChangeEvent<HTMLInputElement>) => cb(e.target.value);
  const onClear = () => cb('');
  const onBlur = (e: FocusEvent<HTMLInputElement>) => cb(e.target.value.trim());
  return { onChange, onClear, onBlur };
}
